// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.shopify-section > .apps-root {
  background-color: var(--background-color);
}`, "",{"version":3,"sources":["webpack://./src/Common/components/shared.bundle/styles/apps.scss"],"names":[],"mappings":"AACE;EACE,yCAAA;AAAJ","sourcesContent":[".shopify-section {\n  >.apps-root {\n    background-color: var(--background-color);\n  }\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
